{
  "AGENT_BOTS": {
    "HEADER": "Boty",
    "LOADING_EDITOR": "Ładowanie edytora...",
    "DESCRIPTION": "Boty agentów są jak najbardziej fantastyczni członkowie Twojego zespołu. Mogą zajmować się drobnymi sprawami, dzięki czemu Ty możesz skupić się na tym, co naprawdę ważne. Wypróbuj je! Możesz zarządzać swoimi botami z tej strony lub tworzyć nowe za pomocą przycisku 'Dodaj bota'.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "System bot",
    "GLOBAL_BOT_BADGE": "System",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot avatar deleted successfully",
      "ERROR_DELETE": "Error deleting bot avatar, please try again"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Wybierz bota agenta",
      "DESC": "Przypisz Bota Agenta do swojej skrzynki odbiorczej. Mogą oni obsługiwać wstępne rozmowy i przekazywać je do żywego agenta, gdy jest to konieczne.",
      "SUBMIT": "Aktualizuj",
      "DISCONNECT": "Odłącz bota",
      "SUCCESS_MESSAGE": "Pomyślnie zaktualizowano bota agenta.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Pomyślnie odłączono bota agenta.",
      "ERROR_MESSAGE": "Nie udało się zaktualizować bota agenta. Proszę spróbować ponownie.",
      "DISCONNECTED_ERROR_MESSAGE": "Nie udało się odłączyć bota agenta. Proszę spróbować ponownie.",
      "SELECT_PLACEHOLDER": "Wybierz bota"
    },
    "ADD": {
      "TITLE": "Add Bot",
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "API": {
        "SUCCESS_MESSAGE": "Bot dodany pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się dodać bota. Proszę spróbować później."
      }
    },
    "LIST": {
      "404": "Nie znaleziono botów. Możesz utworzyć bota klikając przycisk 'Dodaj bota'.",
      "LOADING": "Pobieranie botów...",
      "TABLE_HEADER": {
        "DETAILS": "Szczegóły bota",
        "URL": "Adres URL webhooka",
        "ACTIONS": "Akcje"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "TITLE": "Usuń bota",
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Are you sure you want to delete {name}?",
        "YES": "Tak, usuń",
        "NO": "Nie, anuluj"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot usunięty pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się usunąć bota. Proszę spróbować ponownie."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edytuj",
      "TITLE": "Edytuj bota",
      "API": {
        "SUCCESS_MESSAGE": "Bot zaktualizowany pomyślnie.",
        "ERROR_MESSAGE": "Nie udało się zaktualizować bota. Proszę spróbować ponownie."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Token dostępu",
      "DESCRIPTION": "Copy the access token and save it securely",
      "COPY_SUCCESSFUL": "Access token copied to clipboard",
      "RESET_SUCCESS": "Access token regenerated successfully",
      "RESET_ERROR": "Unable to regenerate access token. Please try again"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot avatar"
      },
      "NAME": {
        "LABEL": "Nazwa bota",
        "PLACEHOLDER": "Enter bot name",
        "REQUIRED": "Nazwa bota jest wymagana"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Co robi ten bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Adres URL webhooka",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL is required"
      },
      "ERRORS": {
        "NAME": "Nazwa bota jest wymagana",
        "URL": "Webhook URL is required",
        "VALID_URL": "Please enter a valid URL starting with http:// or https://"
      },
      "CANCEL": "Anuluj",
      "CREATE": "Create Bot",
      "UPDATE": "Update Bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configure a webhook bot to integrate with your custom services. The bot will receive and process events from conversations and can respond to them."
    },
    "TYPES": {
      "WEBHOOK": "Bot webhook"
    }
  }
}
